export default {
  settings: 'Ustawienia',
  choose_student: 'Wybór dziecka',
  choose_profile: 'Wybierz profil',
  empty_students_title: 'Do Twojego konta nie ma aktualnie przypisanych uczniów.',
  empty_students_desc: 'Jeżeli Twoje dziecko uczęszcza w tym roku na kurs Early Stage, skontaktuj się z Twoją filią.',
  homeworks: 'Prace domowe',
  grades: 'Oceny',
  attendances: 'Obecności i tematy',
  task_list: 'Prace domowe',
  attendances_list: 'Obecności i tematy',
  grades_list: 'Oceny',
  sidebar_account_header: 'Moje konto',
  sidebar_account_payments: 'Płatności',
  sidebar_account_agreement: 'Pobierz umowę',
  sidebar_account_change_password: 'Zmień hasło',
  sidebar_account_payments_returns: 'Dane do zwrotów',
  sidebar_declarations: 'Kontynuacja nauki',
  sidebar_declarations_advance: 'Kontynuacja nauki i zaliczka',
  payments_returns_description: 'Na podane poniżej konto będziemy mogli zwrócić Ci nadpłacone środki (np. po rezygnacji z kursu).',
  grades_notfound: 'Brak ocen do wyświetlenia',
  class_list_show: 'Zobacz listę zajęć',
  class_list_hide: 'Ukryj listę zajęć',
  class_room: 'Sala',
  join_meeting: 'dołącz do spotkania',
  loading: 'Ładowanie',
  subject: 'Temat',
  attendances_subject_empty: 'Brak tematu',
  subject_empty: 'Kliknij, żeby zobaczyć załącznik',
  subject_not_found: 'Brak treści pracy domowej',
  subjects_show: 'Pokaż tematy',
  subjects_hide: 'Ukryj tematy',
  lector_add_task: 'Szczegóły pracy domowej',
  level: 'Poziom',
  counter_size: 'Wykorzystano',
  counter_size2: 'z możliwych',
  uploaded_files_info: 'Dodane pliki można wysłać w ciągu 24h, po tym czasie trzeba je załadować ponownie.',
  show_task_prefix: 'Kliknij w przycisk poniżej, aby przejść do zadania:',
  show_task: 'Ćwiczenie online',
  maretials_online: 'Materiały online',
  maretials_online_list: 'Materiały online',
  empty_homework_title: 'Brak treści pracy domowej',
  todo: 'Termin oddania pracy domowej: ',
  lector: 'Lektor',
  group: 'Grupa',
  online: 'Zajęcia online',
  privacy: 'Polityka Prywatności',
  privacy_and_cookies: 'Polityka prywatności',
  payments_help_center: 'Centrum pomocy płatności',
  contact: 'Kontakt',
  cookies: 'Polityka Cookies',
  regulations: 'Regulamin',
  monitor_system_progress: 'Jak oceniamy?',
  send_new_files: 'Wyślij nowe pliki do lektora',
  cookies_preferences: 'Preferencje plików cookie',
};
